export const hCaptchaSiteKey = '30a250d5-7dbd-41e3-8907-bff59847ba96';